// credit to https://codepen.io/anon/pen/WXRLrG
// Codepens are licensed under MIT
export class Confetti {
  constructor(canvas, palette) {
    this.canvas = canvas;
    this.context = canvas.getContext('2d');
    this.style = palette[Math.floor(this.range(0, palette.length))];
    this.rgb = `rgba(${this.style[0]}, ${this.style[1]}, ${this.style[2]}`;
    this.r = Math.floor(this.range(2, 6));
    this.r2 = 2 * this.r;
    this.replace();
  }

  replace = () => {
    const w = this.canvas.width;
    const h = this.canvas.height;

    this.opacity = 0;
    this.dop = 0.03 * this.range(1, 4);
    this.x = this.range(-this.r2, w - this.r2);
    this.y = this.range(-20, h - this.r2);
    this.xmax = w - this.r;
    this.ymax = h - this.r;
    this.vx = this.range(0, 2) - 1;
    return (this.vy = 0.7 * this.r + this.range(-1, 1));
  };

  draw = () => {
    const ref = this.x;
    this.x += this.vx;
    this.y += this.vy;
    this.opacity += this.dop;
    if (this.opacity > 1) {
      this.opacity = 1;
      this.dop *= -1;
    }
    if (this.opacity < 0 || this.y > this.ymax) {
      this.replace();
    }
    if (!(ref > 0 && ref < this.xmax)) {
      this.x = (this.x + this.xmax) % this.xmax;
    }
    return this.drawCircle(
      Math.floor(this.x),
      Math.floor(this.y),
      this.r,
      `${this.rgb},${this.opacity})`,
    );
  };

  range = (a, b) => (b - a) * Math.random() + a;

  drawCircle = (x, y, r, style) => {
    this.context.beginPath();
    this.context.arc(x, y, r, 0, 2 * Math.PI, false);
    this.context.fillStyle = style;
    return this.context.fill();
  };
}
